// extracted by mini-css-extract-plugin
module.exports = {"safeUnsafeButtons":"styles_safeUnsafeButtons__2Ydnl","checkmarkButton":"styles_checkmarkButton__3XNgJ"};